import TemplateView from "../TemplateView";

export default class EditButton extends TemplateView {

    constructor($containerEl, onClick) {
        super($containerEl);
        this.onClick = onClick;
    }

    templateHtml() {
        return "<div class='editButton'></div>"
    }

    afterRender() {
        if (this.onClick) {
            this.$el.on("click", this.onClick);
        }
    }

    setClickHandler(onClick) {
        this.$el.on("click", onClick);
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/EditButton.js